<template>
  <tile-selector :id="`tile-selector_question-${question.number}-device`" :question="updatedQuestion" @input="handleSelect" :value="value" :readonly="readonly" />
</template>

<script>
import { getDeviceFromType } from './deviceTypes';
import TileSelector from './TileSelector.vue';

const { DEVICE_MFGS } = require('@virtual-peaker/vp-common').vpConstants;

export default {
  name: 'question-device',
  inject: { program: 'program' },
  props: {
    question: Object,
    supportedDevices: Array,
    readonly: Boolean,
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    handleSelect(key) {
      this.$emit('input', key);
      this.$emit('reset');
    },
  },
  computed: {
    updatedQuestion() {
      let devices = this.question.supportedDevices;
      if (this.question.supportedDevices.some(device => device === 'tesla')
        && this.program.enableTeslaAppEnrollment
      ) devices = devices.toSpliced(devices.indexOf('tesla'), 1, 'teslaExternalEnroll');

      if (this.question.supportedDevices.some(device => device === 'enphase')
      && this.program.enableEnphaseDirectInstall
      ) {
        devices = devices.toSpliced(devices.indexOf('enphase'), 1, 'enphaseDirectInstall');
      }
      const rawItems = this.question.deviceType ? getDeviceFromType(this.question.deviceType, devices) : [];
      const items = rawItems
        .map(i => ({
          ...i,
          value: i.mfg,
          icon: i.iconStyle,
          label: DEVICE_MFGS[i.mfg] || i.mfg || '',
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      return { ...this.question, items };
    },
  },
  components: { TileSelector },
};
</script>
